export const enum SelectActions {
  SELECTFOCUS = 'selectfocus',
  OPEN = 'open',
  CLOSE = 'close',
}

export type SelectReducerAction =
  | { type: SelectActions.SELECTFOCUS }
  | { type: SelectActions.OPEN }
  | { type: SelectActions.CLOSE };

/** Select reducer function used for managing the opening / closing state of the select menu. */
export function reducer(state: boolean, action: SelectReducerAction): boolean {
  const { type } = action;

  if (type === SelectActions.SELECTFOCUS) {
    return !state;
  }

  if (type === SelectActions.OPEN) {
    return true;
  }

  if (type === SelectActions.CLOSE) {
    return false;
  }

  return state;
}
